import chatApi from "../api/chat-api";

const put = async (payload) => {
    const resp = await chatApi.edit(payload);
    if (resp.status !== "SUCCESS") {
        throw resp.responseMsgTh;
    }
    return resp;
}

const search = async (condition) => {
	try {
		const result = await chatApi.search(condition);
		return result;
	} catch (err) {
		console.error(err);
		throw err;
	}
};

const getById = async (payload) => {
    const resp = await chatApi.getById(payload);
    if (resp.status !== "SUCCESS") {
        throw resp.responseMsgTh;
    }
    return resp;
}

const read = async (payload) => {
    const resp = await chatApi.read(payload);
    if (resp.status !== "SUCCESS") {
        throw resp.responseMsgTh;
    }
    return resp;
}

const closeChat = async (payload) => {
    const resp = await chatApi.closeChat(payload);
    if (resp.status !== "SUCCESS") {
        throw resp.responseMsgTh;
    }
    return resp;
}

const countReadable = async (payload) => {
    const resp = await chatApi.countReadable(payload);
    if (resp.status !== "SUCCESS") {
        throw resp.responseMsgTh;
    }
    return resp;
}

const chatService = {
    put,
    search,
    getById,
    read,
    closeChat,
    countReadable
};

export default chatService;